<script setup>
import { COMPONENT_VISIBILITY_ENUM } from "~/utils/constants";

import FooterSpecificMenuSection from "./FooterSpecificMenuSection.vue";
import FooterAboutProjectSection from "./FooterAboutProjectSection.vue";
import FooterBrandSection from "./FooterBrandSection.vue";
import FooterBottomBar from "./FooterBottomBar.vue";

const footerDataBlock = useState("footerBlock", () => null);

const hasFooterDataBlock = computed(() => {
  return (
    footerDataBlock.value &&
    footerDataBlock.value.visibility === COMPONENT_VISIBILITY_ENUM.show &&
    footerDataBlock.value?.richText?.length > 0
  );
});
</script>

<template>
  <footer class="w-full">
    <div
      :class="
        cn(
          'grid grid-cols-1 md:grid-cols-[1fr_2fr] md:grid-rows-2 xl:grid-cols-[auto_1fr_1fr] xl:grid-rows-1',
          'gap-x-12 gap-y-8 md:gap-y-0 xl:gap-x-16',
          'px-8 py-8 lg:pt-4 lg:pb-12 xl:gap-x-12 3xl:pt-8 3xl:pb-16 3xl:px-16 3xl:gap-x-16',
          'bg-primary-darker',
        )
      "
    >
      <FooterBrandSection />

      <FooterAboutProjectSection
        :footer-data-block="footerDataBlock"
        class="md:pt-8 order-3 xs:order-2 md:order-3 xl:order-2"
        :class="
          cn(
            hasFooterDataBlock
              ? 'w-full xl:flex-1 col-span-1 md:col-span-2 xl:col-span-1'
              : 'flex-grow hidden',
          )
        "
      />

      <FooterSpecificMenuSection
        class="md:pt-8 order-2 xl:order-3"
        :class="cn(hasFooterDataBlock ? 'col-span-1' : 'col-span-2')"
      />
    </div>

    <FooterBottomBar />
  </footer>
</template>
